<template>
  <div>
    <el-cascader
      size="small"
      style="width: 100%"
      v-model="value"
      :options="options"
      :props="{ checkStrictly: true }"
      clearable
      @change="change"
    >
    </el-cascader>
  </div>
</template>
<script>
import { resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";
export default {
  components: {},
  props: {
    modelValue: {
      type: [String, Number], // 根据你传递的类型，修改这里的类型
      default: "",
    },
	vals:{
		type:Number,
		default:""
	}
  },
  data() {
    return {
      value: "",
      options: [],
    };
  },
  created() {
	  // if(this.vals){
		 //  this.value = [this.vals]
		 //  console.log('this.value1',this.value)
	  // }
    // 获取商品分类列表
    this.getCategoryList();
  },
  methods: {
    change() {
		console.log("this.value",this.value)
      this.$emit("getValue", this.value[this.value.length-1]);
    },
    getCategoryList() {
      let _this = this;
      _this.axios.get(resolveWeiShopApi("/api/weishop/admin/category/list")).then((res) => {
        if (res.code == 200) {
          _this.options = _this.addIdAsValueToTree(res.data);
		  if(_this.vals){
			  // 查找 id 为 3 的节点的所有父级
			  const parents = _this.findParents(_this.options, _this.vals, {
			    valueKey: 'category_id',
			    includeCurrent: false
			  });
			  _this.value = [...parents.map(item => item.category_id),_this.vals];
		  }
		  
        } else {
          eltips(res.msg, "error");
        }
      });
    },
    addIdAsValueToTree(tree) {
      // 递归函数遍历树形结构并修改每个节点
      function transformTree(node) {
        // 给当前节点添加新属性 'value'，其值为 'id'
        node.value = node.category_id;
        node.label = node.name;
        // 如果当前节点有子节点，递归调用 transformTree
        if (node.children) {
          node.children.forEach((child) => transformTree(child));
        }
      }
      // 对每个根节点进行递归操作
      tree.forEach((node) => transformTree(node));

      // 返回修改后的树
      return tree;
    },
	/**
	 * 在树形数据中根据指定参数查找所有父级节点
	 * @param {Array} tree 树形数据
	 * @param {*} targetValue 要查找的目标值
	 * @param {Object} options 配置项
	 * @param {string} options.valueKey 节点值字段名，默认 'value'
	 * @param {string} options.childrenKey 子节点字段名，默认 'children'
	 * @param {boolean} options.includeCurrent 是否包含当前节点，默认 false
	 * @returns {Array} 父级节点数组，从根节点到直接父节点
	 */
	findParents(tree, targetValue, options = {}) {
	  const {
	    valueKey = 'value',
	    childrenKey = 'children',
	    includeCurrent = false
	  } = options;
	  
	  let result = [];
	  
	  function traverse(nodes, path) {
	    for (const node of nodes) {
	      // 创建当前路径（包含当前节点）
	      const currentPath = [...path, node];
	      
	      // 如果找到目标节点
	      if (node[valueKey] === targetValue) {
	        if (includeCurrent) {
	          result = currentPath; // 包含当前节点
	        } else {
	          result = path; // 不包含当前节点，只包含父级
	        }
	        return true; // 找到目标，停止遍历
	      }
	      
	      // 如果有子节点，递归查找
	      if (node[childrenKey] && node[childrenKey].length > 0) {
	        if (traverse(node[childrenKey], currentPath)) {
	          return true; // 在子树中找到目标，直接返回
	        }
	      }
	    }
	    return false;
	  }
	  
	  traverse(tree, []);
	  return result;
	}
  },
};
</script>
<style lang="less" scoped></style>
